import React from 'react';
import PropTypes from 'prop-types';

import {
  SortableContainer,
} from 'react-sortable-hoc';

// Components
import RsvpListItem from './RsvpListItem';

const RsvpsList = SortableContainer(({
  orderedIds,
  rsvpEntities,
  onEdit,
}) => {
  return (
    <ul className="rsvps-list sortable-list">
      {orderedIds.map((rsvptId, index) => (
        <RsvpListItem
          rsvp={rsvpEntities[rsvptId]}
          key={index}
          index={index}
          onEdit={onEdit}
        />
      ))}
    </ul>
  );
});

RsvpsList.propTypes = {
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  rsvpEntities: PropTypes.shape({}),
  onEdit: PropTypes.func,
  onSortEnd: PropTypes.func,
};

export default RsvpsList;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/RsvpsList.jsx